import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const AccessTypeButton = styled(ToggleButton, { name: 'AccessTypeButton' })({
	flex: 1,
	borderRadius: '10px',
});

export const AccessTypeButtonGroup = styled(ToggleButtonGroup, { name: 'AccessTypeButtonGroup' })(
	({ theme }) => ({
		gap: theme.spacing(4),
		'.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
			borderTopRightRadius: '10px',
			borderBottomRightRadius: '10px',
		},
		'.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
			marginLeft: 0,
			borderLeftColor: 'rgba(0, 0, 0, 0.12)',
			borderTopLeftRadius: '10px',
			borderBottomLeftRadius: '10px',
		},
	}),
);

export const ShareDialogForm = styled('form', { name: 'ShareDialogForm' })(
	({ theme }) => ({
		display: 'flex',
		gap: theme.spacing(4),
		flexDirection: 'column',
	}),
);
